import axios from 'axios';
import {request, loginRequest} from './httpRequest';

export const userService = {
  login,
  logas,
  refreshToken,
  refreshOktaToken,
  logout,
  setProfile,
  getUsers,
  getUser,
};

const { REACT_APP_OKTA_DOMAIN, REACT_APP_OKTA_CLIENT_ID } = process.env;

function login() {
  return loginRequest.get(`login`).then(handleResponse)
  .then(data => {
    // store user details and jwt token in local storage to keep user logged
    localStorage.setItem('accessToken', data.tokens.accessToken);
    localStorage.setItem('refreshToken', data.tokens.refreshToken);
    localStorage.setItem('user', JSON.stringify(data.user));
    /*console.log(localStorage.getItem('okta-token-storage')==null);
    if (localStorage.getItem('okta-token-storage')==null) {
      return Promise.reject("thetrawin");
    }*/
    return data; 
  })
  .catch(error => {
    return Promise.reject(error);
  });
}

function logas(id, secret) {
  return loginRequest.post(`logas/` + id, { secretKey : secret })
  .then(handleResponse)
  .then(data => {
    // store user details and jwt token in local storage to keep user logged
    localStorage.setItem('accessToken', data.tokens.accessToken);
    localStorage.setItem('refreshToken', data.tokens.refreshToken);
    localStorage.setItem('user', JSON.stringify(data.user));
    return data; 
  })
  .catch(error => {
    return Promise.reject(error.response.data.error);
  });
}

function refreshOktaToken(refreshToken) {
  const params = new URLSearchParams();
  if (REACT_APP_OKTA_CLIENT_ID) {  params.append('client_id', REACT_APP_OKTA_CLIENT_ID);}
  params.append('grant_type', 'refresh_token');
  //params.append('scope', 'openid offline_access profile email');
  params.append('refresh_token', refreshToken);
  const config = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }
  return axios.post(`https://${REACT_APP_OKTA_DOMAIN}/oauth2/default/v1/token`, params, config)
  .then((result) => {
    let oktaObject = JSON.parse(localStorage.getItem('okta-token-storage')||'{}');
    oktaObject.accessToken.accessToken = result.data.access_token;
    localStorage.setItem('okta-token-storage', JSON.stringify(oktaObject));
    /*localStorage.setItem('accessToken', result.data.access_token);
    localStorage.setItem('refreshToken', result.data.refresh_token);*/
    return result.data;
  })
  .catch(err => {
    return Promise.reject(err);
  })
}

function refreshToken(token){
  return loginRequest.post(`refresh`, { "refreshToken" : token })
  .then(handleResponse)
  .then(data => {
    localStorage.setItem('accessToken', data.accessToken);
    return data; 
  })
  .catch(error => {
    if(error.response.status === 401){
      logout();
    };
    return Promise.reject(error);
  });
}

function logout() {
  // remove user and token from local storage to log user out
  localStorage.removeItem('user');
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  window.location.href = '/';
}

function setProfile(email : string) {
  const filter = {
    "where": {
      "email": email
    }
  }
  return request.get("users?filter="+JSON.stringify(filter)).then(handleResponse)
  .then(data => {
    return JSON.stringify(data[0]);
  })
  .catch(error => {
    return Promise.reject(error.response.data.error);
  })
}

/*function setProfile(id, data) {  
  return request.put(`users/` + id,  
    JSON.stringify(data), 
    { headers: { 'Content-Type': 'application/json' } })
  .then(handleResponse)
  .then(data => {    
    return data; 
  })
  .catch(error => {
    return Promise.reject(error.response.data.error);
  });
}*/

function getUsers() {
  return request.get('/users')
  .then(handleResponse)
  .then(data => {    
    return data; 
  })
  .catch(error => {
    return Promise.reject(error.response.data.error);
  });
}

function getUser(id) { 
  return request.get('/users/' + id)
  .then(handleResponse)
  .then(data => {    
    return data; 
  })
  .catch(error => {
    return Promise.reject(error.response.data.error);
  });
}

function handleResponse(response) {
  // deal with API response
  return response.data;
}